<template>
  <el-form :model="typeSearchForm" ref="typeSearchForm" size="mini" :inline="true" :rules="searchFormRules">
    <el-col :span="3">
      <el-form-item prop="typeModel">
        <el-input placeholder="型号编码" v-model="typeSearchForm.typeModel" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="3">
      <el-form-item prop="typeName">
        <el-input placeholder="型号名称" v-model="typeSearchForm.typeName" clearable></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button size="mini" type="primary" @click="resetSearchForm">清空</el-button>
      </el-form-item>
    </el-col>
    <el-col :span="1.5">
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="submitTypeSearchForm"
                   :loading="getTypesLoading">查询
        </el-button>
      </el-form-item>
    </el-col>
  </el-form>
</template>

<script>
  import {validateInput} from '../../../../common/validator'
  export default {
    name: "search",
    data(){
      return{
        searchFormRules: {
          typeModel: [
            {validator: function (rule, value, callback) {
                validateInput(rule, value, callback,0,16,true,false,true,false,false,false,false)
              }, trigger: 'blur'}],
          typeName: [{validator: function (rule, value, callback) {
              validateInput(rule, value, callback,0,16,true,true,false,false,false,false,false)
            }, trigger: 'blur'}],
        }
      }
    },
    props:{
      typeSearchForm:{},
      getTypesLoading: false,
    },
    methods:{
      resetSearchForm() {
        for(let item in this.typeSearchForm) {
          if(this.typeSearchForm[item]){
            this.typeSearchForm[item] = ''
          }
        }
        this.submitTypeSearchForm()
      },
      submitTypeSearchForm(){
        this.$emit("submitTypeSearchForm")
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/search.vue